module.exports = __webpack_public_path__ + "static/media/vapeur.1d06f193.png";